export class CreateApplicationProfessionalBodiesEcConstants {
    static STEP_TITLE = "Professional bodies";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL = "Are the electrical engineer's details required?";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markEngineerAsNotApplicable";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL = "Copy applicant details to electrical engineer?";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME = "copyApplicantDetailsToEngineer";
    static MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_LABEL = "Are the electrical contractor's details required?";
    static MARK_ELECTRICAL_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markElectricalContractorAsNotApplicable";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL = "Copy applicant details to electrical contractor?";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "copyApplicantDetailsToElectricalContractor";
    static ENGINEER_LABEL = "Electrical engineer";
    static ELECTRICAL_CONTRACTOR_LABEL = "Electrical contractor";
    static ENGINEER_FORM_CONTROL_NAME = "engineerRecipients";
    static ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "electricalContractorRecipient";
}
